const state = {
  acdCurrent: null
}

const getters = {
  acdCurrent (state) {
    return state.acdCurrent
  }
}

const mutations = {
  SET_ACD_CURRENT (state, acdCurrent) {
    state.acdCurrent = acdCurrent
  }
}

const actions = {
  ACTION_SET_ACD_CURRENT ({ commit }, data) {
    commit('SET_ACD_CURRENT', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
